import { render } from "./IndexLivraison.vue?vue&type=template&id=402cb3f3&scoped=true"
import script from "./IndexLivraison.vue?vue&type=script&lang=js"
export * from "./IndexLivraison.vue?vue&type=script&lang=js"

import "./IndexLivraison.vue?vue&type=style&index=0&id=402cb3f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402cb3f3"]])

export default __exports__